// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"604":"1c596c1bec840f7a","917":"0da4cc761a3fb189"}[chunkId] + ".js";
};